let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { hubSpotResetCss } from './HubSpotReset';
import { normalizeCss } from './NormalizeCss';
import { utilsCss } from './CssUtils';
const GlobalStyles = createGlobalStyle(_t || (_t = _`
  ${0}
  ${0}
  ${0}
`), normalizeCss, hubSpotResetCss, utilsCss);
export default GlobalStyles;